export default __webpack_public_path__ + "static/media/cli-gramado.9bdd60b1.jpg";